function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M13 3c.513 0 .936.386.993.883L14 4v4.923c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L12 8.923V5H4v14h8v-3.923c0-.513.386-.936.883-.993l.117-.007c.513 0 .936.386.993.883l.007.117V20c0 .513-.386.936-.883.993L13 21H3c-.513 0-.936-.386-.993-.883L2 20V4c0-.513.386-.936.883-.993L3 3h10zm4.595 5.116l.105.064.098.078 3.873 3.5c.034.03.065.063.094.097l.07.094.038.063c.17.302.17.674 0 .976l-.052.083-.074.094-.076.077-3.873 3.5c-.41.37-1.042.338-1.412-.071-.342-.379-.341-.947-.017-1.323l.088-.09 1.945-1.758H7c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L7 11.5h11.403l-1.946-1.758c-.378-.342-.434-.907-.15-1.314l.079-.099c.313-.346.814-.422 1.21-.213z"
});

var SvgLogOut = function SvgLogOut(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogOut, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/log-out.0f5cc0d3.svg";
export { ForwardRef as ReactComponent };